import { ColorFilters } from './color-filters';
import { ForYouFilterType } from './constants';
import { GroupedFilters } from './grouped-filters';

export const getForYouFilters: (showColorChipForYou: boolean) => ForYouFilterType[] = (
  showColorChipForYou: boolean
) => {
  return [
    {
      id: 'show-me',
      displayName: 'Show me',
      iconName: 'view-small',
      component: GroupedFilters,
      hide: false,
    },
    {
      id: 'color',
      displayName: 'Color',
      iconName: 'edit-small',
      component: ColorFilters,
      hide: !showColorChipForYou,
    },
  ];
};
